import MoneyInScreen from 'features/believe/application/MoneyInScreen/MoneyInScreen';
import React from 'react';

export default function Page() {
  return <MoneyInScreen />;
}
